import { http } from "../http/Http";
import { ServiceResponse } from "../models/ServiceResponse";
import { PartnerType } from "../models/PartnerType";

export class PartnerTypeService {

    getPartnerTypes = async (): Promise<ServiceResponse<PartnerType[]>> => {
        const { data } = await http.get<ServiceResponse<PartnerType[]>>("PartnerType/GetAll");
        return data;
    };
}